export default __webpack_public_path__ + "static/media/ic-previous-test.08c1ee8a.svg";